<template>
  <input
    ref="inputRef"
    type="text"
    :class="[{ 'tw-text-right': textRight }, inputClass]"
    :autofocus="autofocus"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    :disabled="disableInput"
    :placeholder="placeholder"
  />
</template>

<script>
import { computed, watch } from "vue"
import { useCurrencyInput } from "vue-currency-input"
import { useCurrencyFormat } from "@/composables/useCurrencyFormat"

export default {
  name: "CurrencyInput",
  props: {
    modelValue: {
      type: Number,
      required: false,
      default: undefined,
      validator: (value) => value === null || value === undefined || typeof value === "number",
    },
    currency: {
      type: String,
      default: "USD",
    },
    options: {
      type: Object,
      required: true,
    },
    inputClass: {
      type: String,
      required: false,
      default: "",
    },
    textRight: {
      type: Boolean,
      required: false,
      default: true,
    },
    disableInput: {
      required: false,
      default: false,
      type: Boolean,
    },
    currencyDisplay: {
      required: false,
      default: "symbol",
      type: String,
    },
    placeholder: {
      required: false,
      default: null,
      type: String,
    },
    autofocus: {
      required: false,
      default: true,
      type: Boolean,
    },
  },

  // eslint-disable-next-line vue/no-unused-emit-declarations
  emits: ["blur", "focus", "update:modelValue", "input", "change"],

  setup(props) {
    const { currency } = useCurrencyFormat()
    const resolvedCurrency = computed(() => props.currency || currency.value || "USD")
    const buildOptions = () => ({
      ...props.options,
      currency: resolvedCurrency.value,
      currencyDisplay: props.currencyDisplay,
    })

    const { inputRef, setValue } = useCurrencyInput(buildOptions())

    watch(
      () => props.modelValue,
      (newValue) => {
        setValue(newValue ?? null)
      },
      { immediate: true },
    )

    return { inputRef, setValue }
  },
}
</script>
